<script lang="ts" setup>
import type { IAppProps } from '@/interfaces/IAppProps'
import { useEntryProps } from '@/composable/useDatasetProps'
import Brand from './BrandLogo.vue'
import LanguageDropdown from './LanguageDropdown.vue'
import LiveChat from './LiveChat.vue'
import NavTab from './NavTab.vue'
import UserInfo from './UserInfo.vue'

const { isApp } = useEntryProps<IAppProps>()
</script>

<template>
    <header class="header">
        <div class="container">
            <div class="header-large">
                <div class="header-col">
                    <div class="header-tools">
                        <LanguageDropdown />
                    </div>
                </div>
                <Brand />
                <LiveChat />
            </div>
            <div v-show="!isApp">
                <div class="header-small">
                    <Brand />
                </div>
                <div class="layout-user-info">
                    <UserInfo />
                </div>
                <NavTab />
            </div>
        </div>
    </header>
</template>
